import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PerformanceSummary } from '@/hooks/usePartnerAnalytics';

interface PerformanceFunnelChartProps {
  contractors: PerformanceSummary[];
}

export function PerformanceFunnelChart({ contractors }: PerformanceFunnelChartProps) {
  const stages = [
    { 
      label: 'Total Registered', 
      count: contractors.length,
      percentage: 100
    },
    { 
      label: 'Has Documents', 
      count: contractors.filter(c => c.total_documents > 0).length,
      percentage: 0
    },
    { 
      label: 'Under Review', 
      count: contractors.filter(c => c.pending_documents > 0).length,
      percentage: 0
    },
    { 
      label: 'Partially Approved', 
      count: contractors.filter(c => c.verified_documents > 0 && c.pending_documents > 0).length,
      percentage: 0
    },
    { 
      label: 'Fully Approved', 
      count: contractors.filter(c => 
        c.verified_documents > 0 && 
        c.pending_documents === 0 && 
        c.rejected_documents === 0
      ).length,
      percentage: 0
    },
    { 
      label: 'Active (Rated)', 
      count: contractors.filter(c => c.total_ratings > 0).length,
      percentage: 0
    },
  ];

  // Calculate percentages
  stages.forEach((stage, i) => {
    if (i > 0) {
      stage.percentage = contractors.length > 0 ? (stage.count / contractors.length) * 100 : 0;
    }
  });

  const getColor = (percentage: number) => {
    if (percentage >= 80) return 'bg-green-500';
    if (percentage >= 50) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Contractor Journey Funnel</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {stages.map((stage, index) => {
            const width = stage.percentage;
            return (
              <div key={stage.label} className="space-y-1">
                <div className="flex justify-between text-sm">
                  <span className="font-medium">{stage.label}</span>
                  <span className="text-muted-foreground">
                    {stage.count} ({stage.percentage.toFixed(1)}%)
                  </span>
                </div>
                <div className="relative h-12 bg-muted rounded-lg overflow-hidden">
                  <div
                    className={`h-full flex items-center justify-center text-white font-medium transition-all ${
                      index === 0 ? 'bg-primary' : getColor(stage.percentage)
                    }`}
                    style={{ width: `${width}%` }}
                  >
                    {width > 20 && stage.count}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
